<template>
  <b-row class="my-2" id="market-account-edit-input-row-component-root">
    <b-col class="pr-3">
      <b-row>
        <label class="control-label col-4 d-flex justify-content-center"
          >{{ label }}:</label
        >
        <div class="col-8 pl-0">
          <b-input
            v-if="val"
            :value="val"
            @input="$emit('update:val', $event)"
            size="sm"
            class="mr-1 inputsf"
            :disabled="true"
            @submit="preventDefault"
          ></b-input>
          <b-input
            v-else
            size="sm"
            class="mr-1 inputsf"
            v-model="marketAccount[propertyName]"
            :disabled="!mutable"
            @submit="preventDefault"
          ></b-input>
          <!-- this works because marketAccount is a reference to an object, and the
						ref itself is never changed. and instead we are now mutating only the data
						which the ref points to and thus we don't get the "don't mutate props
						directly" error anymore. -->
        </div>
      </b-row>
    </b-col>
    <!-- b-col>
			<b-row>
				<label
					class="control-label col-4 d-flex justify-content-center"
				></label>
				<div class="col-2 pl-0"></div>
			</b-row>
		</b-col -->
  </b-row>
</template>
<script>
export default {
  props: ["propertyName", "label", "mutable", "marketAccount", "val"],
  data() {
    return {};
  },
  methods: {
    preventDefault(evt) {
      evt.preventDefault();
    },
  },
  created() {},
};
</script>
